import React, { useRef } from "react";
import Icon from "../../../components/AppIcon";

const SearchInput = ({
  disabled,
  value,
  onChange,
  onClick,
  onBlur,
  onClear,
  placeholder = "Search...",
  className = "",
}) => {
  const inputRef = useRef(null);

  const handleClear = () => {
    onClear();
    inputRef.current?.focus();
  };

  return (
    <div className={`relative w-full md:max-w-md ${className}`}>
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <Icon name="Search" size={18} className="text-gray-400" />
      </div>
      <input
        disabled={disabled}
        ref={inputRef}
        type="text"
        className="block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onClick={onClick}
        onBlur={onBlur}
        aria-label={placeholder}
      />
      {value && (
        <button
          disabled={disabled}
          type="button"
          className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
          onClick={handleClear}
          aria-label="Clear search"
        >
          <Icon name="X" size={16} />
        </button>
      )}
    </div>
  );
};

export default SearchInput;